let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("b56AA")]).then(() => parcelRequire('25hyE'));